
    
<table class="table">
    <thead>
    <tr>
        <th class="text-end fs-3 pb-0">
            <a href="javascript:void(0)" (click)="linkToPoolUser(homeCompetitorPoolUserAndFormation(), activeGameRound())">
                <span class="" [class]="{'bg-success': hasQualified(HomeSide)}">{{homeCompetitorPoolUserAndFormation().competitor.getName()}}</span>
            </a>  
        </th>
        <th class="text-end">
            <button type="button" class="btn btn-sm bg-totals text-white fs-3 text">
              {{getScore(HomeSide, homeCompetitorPoolUserAndFormation())}}
            </button>
        </th>
        <th class="text-center">-</th>
        <th class=" ">
            <button type="button" class="btn btn-sm bg-totals text-white  fs-3 text">
              {{getScore(AwaySide, awayCompetitorPoolUserAndFormation())}}
            </button>
        </th>
        <th class=" fs-3 text pb-0">
            <a href="javascript:void(0)" (click)="linkToPoolUser(awayCompetitorPoolUserAndFormation(), activeGameRound())">
                <span [class]="{'bg-success': hasQualified(AwaySide)}">{{awayCompetitorPoolUserAndFormation().competitor.getName()}}</span>
            </a>
        </th>
    </tr>
    </thead>
    <tbody>
        @for (gameRound of gameRounds(); track $index) {
            <tr>
                @let homeScore = statisticsGetter().getFormationGameRoundPoints(homeCompetitorPoolUserAndFormation().formation, gameRound, undefined);
                @let awayScore = statisticsGetter().getFormationGameRoundPoints(awayCompetitorPoolUserAndFormation().formation, gameRound, undefined);
                <td class="text-end pt-3">
                    @if(getPercentageFinished(gameRound) > 0 ) {
                        <button type="button" class="btn btn-sm bg-points text-white">{{homeScore}}</button>                        
                    }
                </td>
                <td class="text-end pt-3">
                    @if(100 === getPercentageFinished(gameRound) ) {
                        <button type="button" class="btn btn-sm bg-totals text-white">
                            {{homeScore >= awayScore ? '1' : '0'}}  
                        </button>  
                    }
                </td>
                <td class="text-center px-1">          
                    <button type="button" class="btn btn-{{ activeGameRound() === gameRound ? 'primary' : 'outline-primary' }} mb-1" (click)="selectGameRound.emit(gameRound)">
                        {{gameRound.number}}
                    </button>
                    <div class="d-flex flex-column align-items-end">
                        <ngb-progressbar-stacked class="mb-1" style="height: 5px; width: 100%; max-width:2.5rem;">
                            @for(progressColumn of getGameRoundProgressColumns(gameRound); track $index){
                                <ngb-progressbar type="{{progressColumn.gameState === GameStateFinished ? 'primary' : 'secondary'}}" [value]="progressColumn.percentage" height="0.5rem"></ngb-progressbar>
                            }
                        </ngb-progressbar-stacked>                
                    </div>                                        
        

                </td>
                <td class=" pt-3">
                    @if(100 === getPercentageFinished(gameRound) ) {
                        <button type="button" class="btn btn-sm bg-totals text-white">
                            {{awayScore >= homeScore ? '1' : '0'}}  
                        </button>                        
                    }
                </td>
                <td class=" pt-3">
                    @if(getPercentageFinished(gameRound) > 0 ) {
                        <button type="button" class="btn btn-sm bg-points text-white">{{awayScore}}</button>                        
                    }
                </td>   
            </tr>   
        }
    </tbody>
</table>